import { controlPlateField } from './../parker-registration.service';
import { UntypedFormBuilder } from '@angular/forms';
import { ParkerRegistrationDataType } from './../../../base/models/parker-registration-data-type.enum';
import { AvpCustomAdaptor } from './../../../base/shared/syncfusion/avp-custom-adaptor';
import { DataManager } from '@syncfusion/ej2-data';
import { SpinnerService } from './../../../base/spinner/spinner.service';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ClientDTO, ControlPlateType, ParkerRegistrationOffense, ParkerRegistrationType, ParkerRegistrationWithParkerInfoDTO, PenaltyState, ZoneDTO } from 'src/app/base/models/models.swagger.generated';
import { ClientService } from 'src/app/base/services/client/client.service';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { ParkerRegistrationService } from '../parker-registration.service';
import { CommandModel, ToolbarItems, GridModule } from '@syncfusion/ej2-angular-grids';
import { ParkerRegistrationDetailsHelper } from '../parker-registration-detail/parker-registration-details.helper';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { ParkerRegistrationRawDetailComponent } from '../parker-registration-detail/parker-registration-raw-detail/parker-registration-raw-detail.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-parker-registration-raw-table',
    templateUrl: './parker-registration-raw-table.component.html',
    styleUrls: ['./parker-registration-raw-table.component.scss'],
    imports: [GridModule, CommonModule, ParkerRegistrationRawDetailComponent, TranslateModule]
})
export class ParkerRegistrationRawTableComponent extends GridBaseComponent implements OnInit {

  @Input() public zones: ZoneDTO[] = [];

  public ParkerRegistrationType = ParkerRegistrationType;
  public ParkerRegistrationOffense = ParkerRegistrationOffense;
  public ParkerRegistrationDataType = ParkerRegistrationDataType;
  public penaltyStateCancelled = PenaltyState.Cancelled;
  public toolbarOptions?: ToolbarItems[] = ['ColumnChooser'];
  public registrationTypeFilter = GridConstantsFactory.createCheckBoxFilter();
  public offenseCheckboxFilter = GridConstantsFactory.createCheckBoxFilter();
  public controlPlateTypeFilter = GridConstantsFactory.createCheckBoxFilter();
  public activeFilter = GridConstantsFactory.createCheckBoxFilter();
  public defectFilter = GridConstantsFactory.createCheckBoxFilter();
  public controlPlateField = controlPlateField;

  constructor(public translate: TranslateService,
    clientService: ClientService,
    public parkerRegistrationService: ParkerRegistrationService,
    private fb: UntypedFormBuilder,
    private spinnerService: SpinnerService) {
    super(clientService, translate, parkerRegistrationService);
    this.gridCommands = [{
      type: SfCommandButtonType.Edit,
      title: this.translate.instant('i18n.domain.parker-registration.tooltips.view-details'),
      buttonOption:
      {
        cssClass: 'icon-btn',
        iconCss: 'icon-view e-icons'
      }
    } as CommandModel];
  }

  public ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.parkerRegistrationService, this.spinnerService)
    });
    this.isActiveColumnName = 'state';
    this.editDialogTitle = 'i18n.domain.parker-registration.dialog.header-raw';
    this.addDialogTitle = '';
    this.addIndexFindColumnName = 'name';
    this.showSaveButton = false;
  }

  public getClientById(id: number): ClientDTO {
    return this.clientService.clients.find(c => c.id === id);
  }

  public refresh(): void {
    this.grid.refresh();
  }

  public getRegisteredByText(data: ParkerRegistrationWithParkerInfoDTO) {
    return ParkerRegistrationDetailsHelper.getRegisteredByText(data, this.translate);
  }

  public getUnknownParkerControlPlate(data: ParkerRegistrationWithParkerInfoDTO): string {
    const countryCode = data.unknownParkerTagCountryCode ? data.unknownParkerTagCountryCode + ' ' : '';
    return countryCode + data.unknownParkerTagControlPlateNumber;
  }

  public getCountryCode(data: ParkerRegistrationWithParkerInfoDTO): string {
    return data.knownTag ? data.knownTag.countryCode : data.unknownParkerTagCountryCode;
  }

  public getControlPlate(data: ParkerRegistrationWithParkerInfoDTO): string {
    return data.knownTag ? data.knownTag.controlPlateNumber : data.unknownParkerTagControlPlateNumber;
  }

  public formatRegistrationType(data: ParkerRegistrationWithParkerInfoDTO): string {
    return 'i18n.domain.parker-registration.ParkerRegistrationType.' + ParkerRegistrationType[data.type];
  }

  public formatOffenseType(data: ParkerRegistrationWithParkerInfoDTO): string {
    return 'i18n.domain.parker-registration.ParkerRegistrationOffense.' + ParkerRegistrationOffense[data.offense];
  }

  public formatControlPlateType(data: ParkerRegistrationWithParkerInfoDTO): string {
    return 'i18n.shared.controlPlateType.' + ControlPlateType[data.knownTag.controlPlateType];
  }

  protected initializeEditForm(data: any): void {
    this.gridEditForm = this.fb.group({
    });
  }

  protected getEditDialogTitleParams(rowData: any) {
    return { params: '' };
  }
}
